import React, { Fragment } from 'react';
import { compose, branch, renderNothing } from 'recompose';
import Media from 'react-media';
import { Summary } from './style';
import SummaryItem from './summaryItem';
import { NavToggle } from '../toggle';
import { FlexCol, Text } from '../misc';

const OrderSummary = ({
  showOrderSummary,
  toggleOrderSummary,
  total,
  shipping,
  tax,
  subtotal,
  items,
}) => {
  return (
    <Summary open={showOrderSummary}>
      <Media query="(max-width: 52em)">
        {matches => (
          <Fragment>
            {matches && (
              <NavToggle
                isExpanded={true}
                onClick={() => toggleOrderSummary()}
              />
            )}
          </Fragment>
        )}
      </Media>
      <Summary.Items>
        {items.map(item => {
          const { articleID } = item;
          return <SummaryItem key={articleID} {...item} />;
        })}
      </Summary.Items>
      <Summary.PriceContainer withBorder>
        <Summary.PriceRow>
          <Summary.Subtotal>Zwischensumme</Summary.Subtotal>
          <Summary.Price>{subtotal}</Summary.Price>
        </Summary.PriceRow>
        <Summary.PriceRow>
          <Summary.Subtotal>
            Versand mit {shipping.shipping_method}
          </Summary.Subtotal>
          <Summary.Price>{shipping.shipping_rate}</Summary.Price>
        </Summary.PriceRow>
      </Summary.PriceContainer>
      <Summary.PriceContainer>
        <FlexCol>
          <Summary.PriceRow id="price-row">
            <Summary.Total>Summe</Summary.Total>
            <Summary.Price>{total}</Summary.Price>
          </Summary.PriceRow>
          <Text>inkl. MwSt: ({tax})</Text>
        </FlexCol>
      </Summary.PriceContainer>
    </Summary>
  );
};

const hideIfCartIsEmpty = isEmpty => branch(isEmpty, renderNothing);

export default compose(hideIfCartIsEmpty(props => !props.items))(OrderSummary);



// WEBPACK FOOTER //
// ../shop_main/components/summary/index.js